export enum SecureDocStatus {
    INCOMPLETE = 1,
    COMPLETED = 2,
    EXPIRED = 3,
    DRAFT = 4,
    VOID = 5
}



export class SecureDocModel {
    constructor() { }

    ID: string;
    FileID: string;
    DocumentName: string;
    Recipients: string[];
    CompletionPercentage: number;
    Status: number;
    UpdatedAt: string;
}

export interface DroppedField {
    Id: string;
    Type: string;
    XPercent: number;
    YPercent: number;
    WidthPercent: number;
    HeightPercent: number;
    Value?: string;
    Page?: number;
    AssignedRecipient?: string;
    IsCompleted?: boolean;
    CompletedAt?: string;
    IsRequired?: boolean;
}

export const mapToDroppedField = (x: any): DroppedField => {
    return {
        Id: x.element_id.toString(),
        Type: x.element_type,
        XPercent: x.placeholder.x,
        YPercent: x.placeholder.y,
        WidthPercent: x.placeholder.width,
        HeightPercent: x.placeholder.height,
        Value: x.value || "",
        Page: x.placeholder.page,
        IsCompleted: x.is_completed,
        CompletedAt: x.completed_at,
        AssignedRecipient: x.assigned_recipient.recipient_id || x.assigned_recipient.toString(),
        IsRequired: x.is_required || true,
    } as DroppedField;
};

export const mapToSecureDoc = (x: any): SecureDocModel => {
    return {
        ID: x.id,
        FileID: x.file_id,
        DocumentName: x.document_name,
        Recipients: x.recipients,
        CompletionPercentage: x.completion_percent,
        Status: x.status,
        UpdatedAt: x.updated_at,
    } as SecureDocModel;
}

interface OtpInfo {
    ExpiresAt: string;
    OTP: string;
}
export interface RecipientModel {
    RecipientID: string;
    Email: string;
    Name: string;
    OrderNumber: number;
    PhoneNumber?: string;
    Type: string;
    Role: number;
    OTPInfo?: OtpInfo;
    IsCompleted?: boolean;
    IsInviteSent?: boolean;
    Color?: string;
}

export class SecureDocUpdateInfoModel {
    constructor() { }

    ID: string;
    CreatedAt: string;
    UpdatedAt: string;
    FileList: {
        ID: string;
        Name: string;
        Type: string;
        Size?: number;
        IsCompleted?: boolean;
        Base64?: string;
    }[];
    Message: string;
    Recipients: RecipientModel[];
    Settings: {
        IsPasswordProtected: boolean;
        Password: string;
        ReminderCount: number;
    };
    Status: number;
    UserID: string;
    UserName: string;
    CompleteInOrder: boolean;
    Configurations?: DroppedField[];
}

export const mapToSecureDocUpdateInfo = (x: any): SecureDocUpdateInfoModel => {
    return {
        ID: x.id,
        CreatedAt: x.created_at,
        UpdatedAt: x.updated_at,
        FileList: x.files?.map((file: any) => ({
            ID: file.file_id,
            Name: file.file_name,
            Type: file.file_type,
            IsCompleted: file.is_completed,
            Base64: file?.value || "",
        })),
        Message: x.message,
        Recipients: x.recipients?.map((r: any) => ({
            Email: r.email,
            IsCompleted: r.is_completed,
            IsInviteSent: r.is_invite_sent,
            Name: r.name,
            OrderNumber: r.order_number,
            PhoneNumber: r.phone_number,
            RecipientID: r.recipient_id,
            Type: r.type,
            Role: r.role,
            OTPInfo: {
                OTP: r.otpinfo?.otp,
                ExpiresAt: r.otpinfo?.expires_at,
            }
        })),
        Settings: {
            IsPasswordProtected: x.settings?.password_protect,
            Password: x.settings?.password,
            ReminderCount: x.settings?.reminder,
        },
        Status: x.status,
        UserID: x.user_id,
        UserName: x.user_name,
        CompleteInOrder: x.complete_in_order,
    } as SecureDocUpdateInfoModel;
};

export class AddSecureDocModel {
    constructor() { }

    ID: string;
    FileList: {
        ID: string;
        Name: string;
        Type: string;
    }[];
    Message: string;
    Recipients: {
        Email: string;
        Name: string;
        OrderNumber: number;
        PhoneNumber: string;
        RecipientID: string;
        Type: string;
    }[];
    Settings: {
        IsPasswordProtected: boolean;
        Password: string;
        ReminderCount: number;
    };
    UserID: string;
    CompleteInOrder: boolean;
}

export const mapToAddSecureDoc = (x: any): AddSecureDocModel => {
    return {
        ID: x.id,
        FileList: x.files?.map((file: any) => ({
            ID: file.file_id,
            Name: file.file_name,
            Type: file.file_type,
        })),
        Message: x.message,
        Recipients: x.recipients?.map((r: any) => ({
            Email: r.email,
            Name: r.name,
            OrderNumber: r.order_number,
            PhoneNumber: r.phone_number,
            RecipientID: r.recipient_id,
            Type: r.type,
        })),
        Settings: {
            IsPasswordProtected: x.settings?.password_protect,
            Password: x.settings?.password,
            ReminderCount: x.settings?.reminder,
        },
        UserID: x.user_id,
        CompleteInOrder: x.complete_in_order,
    } as AddSecureDocModel;
};

export enum RecipientRoleType {
    SIGNER = 1,
    APPROVER
}
